<template>
  <section class="referral-code-search">
    <SoForm
      v-model="isValid"
      data-testid="customer-search-form"
      @submit="search()"
    >
      <h3 class="mb-5">Voucher code lookup</h3>
      <SoTextField
        v-model.trim="soughtReferralCode"
        label="Voucher Code"
        :rules="[rules.required, rules.referralCode]"
        type="text"
        class="w-50 mb-8"
      >
        <template #append>
          <SoButton
            ref="code-search-btn"
            :loading="isSearching"
            :disabled="isValid === false"
            class="ml-4"
            icon="arrow-right"
            type="primary"
            submit
            large
            data-testid="code-search-btn"
          />
        </template>
      </SoTextField>
      <SoAlert v-if="isCodeNotFound" class="mb-5"> Code not found </SoAlert>
      <SoAlert
        v-else-if="referralQuery?.isError"
        title="Failed to fetch code details"
      />
    </SoForm>
  </section>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoForm from "@/components/formControls/SoForm.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import rules from "@/validators/rules"
  import { ReferralService } from "@/services/operations/ReferralService"
  import { RouteNames } from "@/types/router"
  import { QueryResult } from "@/api/utils/types"
  import { ReferralCodeDetail } from "@/models/operations/referralCodeDetails/referralCodeDetails"

  export default defineComponent({
    components: {
      SoForm,
      SoTextField,
      SoButton,
      SoAlert,
    },
    data() {
      return {
        referralQuery: {} as QueryResult<ReferralCodeDetail | null>,
        soughtReferralCode: "",
        isValid: false,
        rules: rules,
      }
    },
    computed: {
      isSearching() {
        return this.referralQuery?.isFetching
      },
      isCodeNotFound() {
        return (
          this.referralQuery?.isSuccess &&
          this.referralQuery.isFetched &&
          !this.referralQuery.data &&
          !this.referralQuery.isFetching
        )
      },
    },
    watch: {
      "referralQuery.data"(foundCode) {
        if (foundCode) {
          this.$router.push({
            name: RouteNames.AdminReferralCode,
            params: { referralCode: this.soughtReferralCode },
          })
        }
      },
    },
    methods: {
      search() {
        this.referralQuery = ReferralService.getReferralCodeDetails(
          this.soughtReferralCode,
        )
      },
    },
  })
</script>
<style lang="css" scoped>
  .referral-code-search {
    max-width: 100%;
    width: 650px;
  }
</style>
